var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('InformationSection',{attrs:{"id":"S100","sections":_vm.information}}),(_vm.files)?_c('AttachmentSection',{attrs:{"files":_vm.files}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }